import { createFileRoute } from '@tanstack/react-router';
import { VisaoGeralView } from '@/modules/agentes/components/AgentesGestao';

// Pilar Visão geral do módulo Agentes (gestão) — admin-only.
export const Route = createFileRoute('/_authed/agentes_/visao-geral')({
  component: VisaoGeralView,
});
